<template lang='pug'>
  .how-container
    .title(v-text='$t("title")')
    .hows
      .how
        .img-section
          div(class='img img-new img-create-new')
        .description
          .title(v-text='$t("create")')
          .detail(v-text='$t("createDetail")')
      .how
        .img-section
          div(class='img img-new img-earn-new')
        .description
          .title(v-text='$t("earn")')
          .detail(v-text='earnDetailText')
      .how
        .img-section
          div(class='img img-new img-rewarded-new')
        .description
          .title(v-text='$t("rewarded")')
          .detail(v-text='$t("rewardedDetail")')
      .how
        .img-section
          div(class='img img-new img-upgrade-new')
        .description
          .title(v-text='$t("upgrade")')
          .detail(v-text='$t("upgradeDetail")')
</template>

<i18n>
{
  "lng_en": {
    "title": "how it works",
    "create": "Sign up for free",
    "createDetail": "Sign up with your email address or your social media accounts.",
    "earn": "earn points",
    "earnDetail": "Every %{amount} spent earns you one point.",
    "rewarded": "get rewarded",
    "rewardedDetail": "Use points to redeem on Rewards Boutique.",
    "upgrade": "upgrade",
    "upgradeDetail": "Advance to next tier for even more benefits."
  },
  "lng_id": {
    "title": "bagaimana caranya",
    "create": "Daftar Gratis",
    "createDetail": "Daftar dengan alamat email atau akun social media Anda.",
    "earn": "dapatkan poin",
    "earnDetail": "Setiap pembelanjaan %{amount} mendapatkan 1 poin",
    "rewarded": "dapatkan hadiah",
    "rewardedDetail": "Gunakan Poin untuk Menukar Rewards Boutique",
    "upgrade": "upgrade",
    "upgradeDetail": "Naik ke tier berikutnya untuk keuntungan lebih banyak."
  },
  "lng_th": {
    "title": "วิธีใช้งาน ",
    "create": "สมัครสมาชิกฟรี",
    "createDetail": "ลงทะเบียนด้วยอีเมล์ หรือบัญชีโซเชียลมีเดียของคุณ",
    "earn": "รับคะแนน",
    "earnDetail": "เมื่อชอปทุก %{amount} รับ 1 คะแนน",
    "rewarded": "รับของรางวัล",
    "rewardedDetail": "ใช้คะแนนแลกรับของสมนาคุณที่ Reward Boutique",
    "upgrade": "อัปเกรด",
    "upgradeDetail": "สู่ระดับขั้นสมาชิกที่สูงขึ้น เพื่อรับสิทธิประโยชน์มากขึ้น"
  },
  "lng_zh": {
    "title": "如何運作",
    "create": "免費註冊",
    "createDetail": "以電郵地址或社交平台帳戶註冊。",
    "earn": "賺取積分",
    "earnDetail": "每消費%{amount}即可賺取1積分",
    "rewarded": "獲得獎賞",
    "rewardedDetail": "憑積分於獎賞廊兌換",
    "upgrade": "升級",
    "upgradeDetail": "升級會籍享受更多好處"
  },
  "lng_ko": {
    "title": "이용 방법",
    "create": "뷰티 패스 멤버십 가입",
    "createDetail": "이메일 주소 또는 소셜 미디어 계정으로 회원가입하세요. ",
    "earn": "포인트 적립하기",
    "earnDetail": "구매 시 %{amount} 당 오프라인 1/온라인 1.2 포인트가 적립됩니다. ",
    "rewarded": "리워드 교환하기",
    "rewardedDetail": "포인트 사용해서 리워드 부티크 받기",
    "upgrade": "등급 업그레이드",
    "upgradeDetail": "다음 등급으로 업그레이드하여 더 많은 혜택을 즐겨보세요. "
  }
}
</i18n>

<script>
export default {
  props: {
    earnAmountText: String
  },

  computed: {
    earnDetailText () {
      return `${this.$t('earnDetail', { amount: this.earnAmountText })}`
    }
  }
}
</script>

<style lang='scss' scoped>
  .how-container {
    padding: 30px 15px;

    @include media-breakpoint-up(xl) {
      margin-left: auto;
      margin-right: auto;
    }

    > .title {
      @include font-sephora-serif;
      font-size: 30px;
      line-height: 32px;
      text-transform: uppercase;
    }

    > .hows {
      margin-top: 30px;

      @include media-breakpoint-up(sm) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
      }
    }
  }

  .hows {
    > .how {
      align-items: center;
      display: flex;
      margin-bottom: 25px;

      @include media-breakpoint-up(sm) {
        display: block;
        width: 140px;
      }
    }
  }

  .img-section {
    > .img {
      height: 70px;
      margin-right: 10px;
      width: 70px;

      @include media-breakpoint-up(sm) {
        height: 120px;
        margin: 0 auto;
        width: 120px;
      }
    }

    > .img-create {
      background: url('../../../assets/images/account/beauty_pass/icons/BP_Revamp_Howitworks_Web-1.svg');
    }

    > .img-earn {
      background: url('../../../assets/images/account/beauty_pass/icons/BP_Revamp_Howitworks_Web-2.svg');
    }

    > .img-rewarded {
      background: url('../../../assets/images/account/beauty_pass/icons/BP_Revamp_Howitworks_Web-3.svg');
    }

    > .img-upgrade {
      background: url('../../../assets/images/account/beauty_pass/icons/BP_Revamp_Howitworks_Web-4.svg');
    }
  }

  .img-new {
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .img-create-new {
    background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-how-create.png');
  }
  .img-earn-new {
    background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-how-earn.png');
  }
  .img-rewarded-new {
    background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-how-rewarded.png');
  }
  .img-upgrade-new {
    background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-how-upgrade.png');
  }

  .description {
    display: flex;
    flex-direction: column;
    text-align: left;

    @include media-breakpoint-up(sm) {
      text-align: center;
    }

    > .title {
      @include font-weight-medium;
      text-transform: uppercase;

      @include media-breakpoint-up(sm) {
        margin-bottom: 5px;
        margin-top: 15px;
        text-align: center;
      }
    }
  }
</style>
